export default "__VITE_ASSET__ZUrFPT1I__"